import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useEffect, useState } from "react";
import { httpClient } from "../services/http/httpClient";
import { numberWithSpaces } from "./utils";
import Placeholder from "./Placeholder";
import { generateFilter, filterHasUpdated, resetFiltersBelow, } from "../filtering/utils";
import { useEffectUpdate } from "../hooks";
function RemoteCount(props) {
    const { id, endpoint, baseUrl, title, zone, setZone, buttons } = props;
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [filter, setFilter] = useState({});
    useEffect(() => {
        const compoundedFilter = generateFilter(zone, id);
        // will trigger [filter] useEffect if update has occured
        if (filterHasUpdated(setFilter, filter, compoundedFilter)) {
            resetFiltersBelow({ id: id, zone: zone });
            setZone({ ...zone });
        }
    }, [zone]);
    useEffectUpdate(() => {
        setLoading(true);
        httpClient()
            .get("/" + endpoint + ":count", {
            baseURL: baseUrl,
            params: {
                filter: filter,
            },
        })
            .then((res) => {
            const total = res.data.meta.total;
            setCount(total);
            setLoading(false);
        })
            .catch((error) => {
            setLoading(false);
            setError(error.message);
            console.error(error.message);
        });
    }, [filter]);
    if (error !== "") {
        return _jsx(Placeholder, { errorMessage: error });
    }
    if (loading) {
        return _jsx(Placeholder, { loader: true });
    }
    return (_jsxs("div", { id: id, className: "tol-count", children: [buttons, _jsx("p", { style: { textAlign: 'left' }, children: title }), _jsx("h1", { className: "count", children: numberWithSpaces(count) }), _jsx("div", { className: "faded", "aria-hidden": "true", children: _jsx("h1", { children: count }) })] }));
}
export default RemoteCount;
